import { AxiosError } from 'axios';

import { requestCache } from './cache';

import { checkBackendHealth } from 'core/services/health';
import { logout } from 'core/utils/logout';
import { routePaths } from 'modules/auth/constants';

const MAINTENANCE_REDIRECT_STORAGE_KEY = 'maintenanceRedirectAt';
const MAINTENANCE_REDIRECT_COOLDOWN_MS = 30000;

export const errorInterceptor = async (error: AxiosError) => {
  if (error.config) {
    const { baseURL, data, method, url, params } = error.config;

    if (requestCache.has(JSON.stringify({ baseURL, data, method, url, params }))) {
      requestCache.delete(JSON.stringify({ baseURL, data, method, url, params }));
    }
  }

  if (error.message === 'Cancel request') {
    return Promise.reject(error);
  }

  if (error.response === undefined) {
    return Promise.reject(error);
  }

  if (error.request === undefined) {
    return Promise.reject(error);
  }

  const {
    response: { status },
  } = error;

  if (status === 401) {
    logout();
  } else if (status === 503 && window.location.pathname !== routePaths.maintenance) {
    const isHealthy = await checkBackendHealth();

    if (!isHealthy) {
      const now = Date.now();
      let lastRedirect = 0;

      try {
        lastRedirect = Number(sessionStorage.getItem(MAINTENANCE_REDIRECT_STORAGE_KEY) || '0');
      } catch (storageError) {
        console.warn('Unable to read maintenance redirect timestamp.', storageError);
      }

      if (
        !Number.isFinite(lastRedirect) ||
        now - lastRedirect >= MAINTENANCE_REDIRECT_COOLDOWN_MS
      ) {
        try {
          sessionStorage.setItem(MAINTENANCE_REDIRECT_STORAGE_KEY, String(now));
        } catch (storageError) {
          console.warn('Unable to persist maintenance redirect timestamp.', storageError);
        }

        window.location.href = routePaths.maintenance;
      }
    }
  }

  if (status >= 500) {
    console.log('error 500');
  }

  return Promise.reject(error);
};
